export const ANALYTICS_DASHBOARDS = [
  {
    title: "Study Performance Dashboard",
    hover: `<span>What is the predicted health of my study?</span>

						<span class="mb-10">This dashboard represents a grouping of high-level metrics related to enrollment, compliance, and data completion.</span>

						<span>This dashboard provides the following insights:</span>

						<ul>
							<li>Determine the expected completion date for all activities</li>
							<li>See at a glance enrollment curves by country and site</li>
							<li>Identify any daily activities that are causing non-compliance</li>
						</ul>`
  },
  {
    title: "Enrollment Dashboard",
    hover: `<span>Am I on target now and in the future to meet my enrollment goals?</span>

						<span>This dashboard represents a grouping of detailed analytics representing enrollment trends:</span>
						<ul>
							<li>See at a glance enrollment curves by country and site</li>
							<li>Site activation and first visit progress by country and site</li>
							<li>eConsent comprehension quiz metrics</li>
							<li>Review screen failure rankings by country and site</li>
						</ul>`
  },
  // {
  //   title: "Study Executive Dashboard",
  //   hover: ``,
  // },
  {
    title: "Engagement Dashboard"
  },
  {
    title: "Compliance Dashboard",
    hover: `<span>Are there any current or predicted compliance issues?</span>

						<span>This dashboard represents a grouping of detailed analytics representing potential compliance issues and trends:</span>

						<ul>
							<li>Identify any daily activities that are causing non-compliance</li>
							<li>Identify data collection completion metrics to see if data entry is lagging</li>
							<li>Use standard deviations to see outliers in compliance activities</li>
						</ul>`
  },
  {
    title: "Data Management Dashboard",
    hover: `<span>What is the status of data collection, cleaning, verification, and approval? </span>

						<span>This dashboard represents a grouping of detailed analytics representing data management statuses and trends:</span>

						<ul>
							<li>Activity completion percentages</li>
							<li>Activity completion times</li>
							<li>Issues and trends involving data queries</li>
							<li>Timeliness of queries being closed</li>
							<li>Timeliness of activities and forms being entered, verified, approved and signed off</li>
						</ul>`
  },
  {
    title: "Retention Dashboard",
    hover: `<span>Am I seeing any trends that may impede study completion goals?</span>

						<span>This dashboard represents a grouping of detailed analytics for completion trends:</span>

						<ul>
							<li>View the completion status for all scheduled activities</li>
							<li>Spot discontinuation trends</li>
							<li>Review missing data and query trends by site and over time</li>
						</ul>`
  }
];
